var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstArrowsMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 323,
    viewBox: "0 0 585 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.837905,
    y: -0.837905,
    width: 1.67581,
    height: 2.15601,
    transform: "matrix(0 -1 -1 0 18.7148 189.408)",
    stroke: "#D7544F",
    strokeWidth: 1.67581
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.215,
    y: 321.749,
    width: 1.67581,
    height: 2.15601,
    transform: "rotate(-90 235.215 321.749)",
    stroke: "#4E5055",
    strokeWidth: 1.67581
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240.174,
    y: 256.066,
    width: 1.67581,
    height: 2.15601,
    transform: "rotate(-90 240.174 256.066)",
    stroke: "#D7544F",
    strokeWidth: 1.67581
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240.174,
    y: 299.599,
    width: 1.67581,
    height: 2.15601,
    transform: "rotate(-90 240.174 299.599)",
    stroke: "#D7544F",
    strokeWidth: 1.67581
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.004 255.229L239.335 255.229",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.865 321.15L234.375 321.15",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5173 189.647L15.607 189.647C7.66794 189.647 1.23211 183.211 1.23211 175.272V14.895C1.23211 6.95593 7.66802 0.52002 15.6071 0.52002H20.7852",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.209 320.911V320.911C245.913 320.911 252.158 314.666 252.158 306.962V14.895C252.158 6.95592 258.594 0.52002 266.533 0.52002H300.354",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.209 255.182L258.494 255.182V97.7164H562.115V0.758789H582.711",
    stroke: "url(#paint0_linear_722_1368)",
    strokeWidth: 0.479167
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.209 298.761L244.119 298.761C252.058 298.761 258.494 292.325 258.494 284.386V219.333",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.66 255.182V255.182C250.862 255.182 258.321 247.723 258.321 238.521V119.162C258.321 108.461 266.996 99.7868 277.696 99.7868H544.128C554.828 99.7868 563.503 91.1123 563.503 80.4118V19.895C563.503 9.19449 572.177 0.52002 582.878 0.52002H584.574",
    stroke: "#D7544F",
    strokeWidth: 0.645833
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_1368",
    x1: 582.711,
    y1: 0.775091,
    x2: 242.209,
    y2: 0.775089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47892,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstArrowsMd);
export default __webpack_public_path__ + "static/media/first-arrows-md.6282c70f4e9a3f123d2fbd6f2086ea10.svg";
export { ForwardRef as ReactComponent };